import { createTRPCReact } from '@trpc/react-query'
import { httpBatchLink } from '@trpc/client'
import type { AppRouter } from '@shelvi/api'
import { supabase } from './supabase'

export const trpc = createTRPCReact<AppRouter>()

export const trpcClient = trpc.createClient({
  links: [
    httpBatchLink({
      url: `${import.meta.env.VITE_API_URL}/trpc`,
      async headers() {
        const {
          data: { session },
        } = await supabase.auth.getSession()
        return session?.access_token
          ? { Authorization: `Bearer ${session.access_token}` }
          : {}
      },
    }),
  ],
})
